import Vue from "vue";
import Communities from "./vue/Communities";
let communitiesFilter;
if (document.getElementById('communities-filter')) {
  communitiesFilter = new Vue({
    el: '#communities-filter',
    data() {
      return {};
    },
    components: {
      Communities
    },
    methods: {},
    mounted() {}
  });
}
export default communitiesFilter;